export default __webpack_public_path__ + "static/media/order-step5.5147b04b.svg";